/**
 * Class description
 *
 * Created: 2019-08-30
 * @author jonas
 */
import {Timeline, TimelineLite, TweenLite} from "gsap";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {HorribleHeroesGameModuleConfig} from "../../HorribleHeroesGameModuleConfig";
import {HorribleHeroesGameConfig} from "../../HorribleHeroesGameConfig";
import {SoundManager} from "../../resource/sound/SoundManager";

export class SpinStart implements GameRoundPresentation {
    stagger?: number;
    abortStagger?: number;

    /**
     * @constructs
     * @param stagger
     * @param abortStagger
     */
    constructor(stagger?: number, abortStagger?: number) {
        this.stagger = stagger;
        this.abortStagger = abortStagger;
    }

    /**
     * @inheritDoc
     */
    public getAnimation(): Timeline | null {
        const tl: TimelineLite = new TimelineLite();

        // #318 -> 1st point
        HorribleHeroesGameConfig.instance.ABORT_DELAY = 0;

        //#150
        if (HorribleHeroesGameModuleConfig.stickyWilds.holdOnGameRestore()) {
            tl.add(TweenLite.to(() => {
                //blank tween added to provide delay for existing sticky wild animations + multiplier animation
            }, 1.5, {}));
        }

        tl.add(() => {
            SoundManager.playReelsSpinning();

            HorribleHeroesGameModuleConfig.symbolWinAnimation.resetAnimation();
        });

        return tl;
    }
}